import OfflineWrapper from '@/components/custom-offline-wrapper';
import GapMagtekSdkProvider from '@/pages/(gapsdk)/_provider/gap-magtek-sdk-provider';
import GapPrinterSdkProvider from '@/pages/(gapsdk)/_provider/gap-printer-sdk-provider';
import GapSdkProvider from '@/pages/(gapsdk)/_provider/gap-sdk-provider';
import LottiesProvider from '@/pages/(gapsdk)/_provider/lotties-provider';
import CameraProvider from '@/pages/(gapsdk)/_provider/sdk-camera-provider';
import SoundProvider from '@/pages/(gapsdk)/_provider/sound-provider';
import AuthenticatedProvider from '@/pages/(gapsdk)/(authenticated)/_provider/authenticated-provider';
import WarehouseProvider from '@/pages/(gapsdk)/(authenticated)/_provider/warehouse.provider';
import CardEntryAddFundPage from '@/pages/(gapsdk)/(authenticated)/gift-card/add-fund/[code]/card-entry/page';
import CashAddFundPage from '@/pages/(gapsdk)/(authenticated)/gift-card/add-fund/[code]/cash/page';
import ChargeAddFundPage from '@/pages/(gapsdk)/(authenticated)/gift-card/add-fund/[code]/charge/page';
import GiftCardAddFundPage from '@/pages/(gapsdk)/(authenticated)/gift-card/add-fund/[code]/page';
import GiftCardReceiptPage from '@/pages/(gapsdk)/(authenticated)/gift-card/add-fund/[code]/receipt/page';
import ReviewAddFundPage from '@/pages/(gapsdk)/(authenticated)/gift-card/add-fund/[code]/review/page';
import SignaturePage from '@/pages/(gapsdk)/(authenticated)/gift-card/add-fund/[code]/signature/page';
import GiftCardInformationPage from '@/pages/(gapsdk)/(authenticated)/gift-card/gift-card-information/[code]/page';
import GiftCardTransactionPage from '@/pages/(gapsdk)/(authenticated)/gift-card/gift-card-transaction/page';
import GiftCardPage from '@/pages/(gapsdk)/(authenticated)/gift-card/page';
import GiftCardRedeemPage from '@/pages/(gapsdk)/(authenticated)/gift-card/redeem/[code]/page';
import VerifyGiftCardPage from '@/pages/(gapsdk)/(authenticated)/gift-card/verify/page';
import { compose } from '@/utils/compose';
import { Outlet, RouteObject } from 'react-router-dom';

const AuthenticatedRoutes: RouteObject[] = [
  {
    path: '/',
    element: compose(
      <AuthenticatedProvider />,
      <WarehouseProvider />,
      <GapSdkProvider />,
      <LottiesProvider />,
      <SoundProvider />,
      <GapMagtekSdkProvider />,
      <GapPrinterSdkProvider />,
      <CameraProvider />,
      <Outlet />,
    ),
    children: [
      {
        path: '/gift-card',
        children: [
          {
            path: '/gift-card',
            element: <GiftCardPage />,
          },
          {
            path: '/gift-card/verify',
            element: <VerifyGiftCardPage />,
          },
          {
            path: '/gift-card/transactions',
            element: (
              <OfflineWrapper isToast={true}>
                <GiftCardTransactionPage />
              </OfflineWrapper>
            ),
          },
          {
            path: '/gift-card/information/:code',
            element: (
              <OfflineWrapper isToast={true}>
                <GiftCardInformationPage />
              </OfflineWrapper>
            ),
          },
          {
            path: '/gift-card/add-fund/:code',
            element: (
              <OfflineWrapper isToast={true}>
                <GiftCardAddFundPage />
              </OfflineWrapper>
            ),
          },

          {
            path: '/gift-card/add-fund/:code/review',
            element: (
              <OfflineWrapper isToast={true}>
                <ReviewAddFundPage />
              </OfflineWrapper>
            ),
          },
          {
            path: '/gift-card/add-fund/:code/charge',
            element: (
              <OfflineWrapper isToast={true}>
                <ChargeAddFundPage />
              </OfflineWrapper>
            ),
          },
          {
            path: '/gift-card/add-fund/:code/cash',
            element: (
              <OfflineWrapper isToast={true}>
                <CashAddFundPage />
              </OfflineWrapper>
            ),
          },
          {
            path: '/gift-card/add-fund/:code/card-entry',
            element: (
              <OfflineWrapper isToast={true}>
                <CardEntryAddFundPage />
              </OfflineWrapper>
            ),
          },
          {
            path: '/gift-card/redeem/:code',
            element: (
              <OfflineWrapper isToast={true}>
                <GiftCardRedeemPage />
              </OfflineWrapper>
            ),
          },
          {
            path: '/gift-card/add-fund/:code/signature',
            element: (
              <OfflineWrapper isToast={true}>
                <SignaturePage />
              </OfflineWrapper>
            ),
          },
          {
            path: '/gift-card/receipt/:transaction_id',
            element: (
              <OfflineWrapper isToast={true}>
                <GiftCardReceiptPage />
              </OfflineWrapper>
            ),
          },
        ],
      },
    ],
  },
];

export default AuthenticatedRoutes;
